<template>
    <div>        
        <div v-for="(surat, index) in data" :key="index" class="card card-style mt-5 overflow-visible"
        :class="{ 'idle-envelop' : (surat.read.length == 0) }"
        >
				<div class="mt-n4 mx-auto rounded-circle shadow-xl bg-blue-dark d-flex justify-content-center align-items-center" style="height: 50px; width: 50px;">
					<i class="bi bi-mailbox font-25 d-block pb-1"></i>
				</div>
				<div class="content">
					<div class="px-3 mb-n3">
						<h5 class="font-700">{{ surat.perihal }}</h5>

                        <p>Dari: {{ surat.pengirim }}</p>

                        <div v-if="surat.read.length > 0 || surat.memo != null || surat.tembusan != null">
                            <span v-if="surat.read.length > 0" class="text-success"><i class="bi bi-check2-all"></i></span>
                            <span v-if="surat.memo != null" class="text-success"><i class="bi bi-forward-fill"></i></span>
                            <span v-if="surat.tembusan != null" class="text-success"><i class="bi bi-hand-thumbs-up"></i></span>
                        </div>

                        <p>{{ surat.tgl_surat }}</p>

						<div class="d-flex justify-content-between justify-content-md-center mb-3">
                            <router-link :to="{ name: 'envelope.show', params: {id: surat.id_sm, kode: kode} }">
                                <div class="btn-full btn btn-xs border-blue-dark color-blue-dark bg-white">

                                    Selengkapnya
                                </div>
                            </router-link>
						</div>
					</div>
				</div>
			</div>

    </div>
</template>

<script>
import { mapMutations, mapActions, mapState } from 'vuex'

export default {
    props: {
        data: {
            type: Array
        },
        kode: {
            type: String
        }
    },
    created(){
        console.log(this.kode)
    }
}
</script>

<style scoped>
.cursor-pointer { cursor: pointer; }
.idle-envelop {
	background-color: #B9D7FF !important; 
	color: #FFF !important;
}
</style>    
